import Vue from "vue";
import VueProgressBar from 'vue-progressbar'
 Vue.use(VueProgressBar, {
    color: '#1bc5bd',
    failedColor: 'red',
    height: '3px',
     inverse: true
});